/**
 * @license
 *
 * Copyright IBM Corp. 2020, 2021
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

import './content-group-pictograms';
import '../content-group/index';
import '../content-item/index';
import '../pictogram-item/pictogram-item';
import '../link-with-icon/link-with-icon';
